import React from 'react';

import { useBuildInfo } from './useBuildInfo';
import { useFormatBuildInfo } from './useFormatBuildInfo';

import './InfoBar.custom.scss';
import './InfoBar.theme.scss';

function InfoBar() {
  const buildInfo = useBuildInfo();
  const data = useFormatBuildInfo(buildInfo);

  return (
    <div className="info-bar--container">
      <div className="info-bar--additional">
        <span className="rx-btn-text">
          <span className="rx-btn-text-container">Content Overview</span>
        </span>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        {!!data.lastUpdated && (
          // eslint-disable-next-line jsx-a11y/tabindex-no-positive
          <a className="rx-btn rx-btn--small rx-btn--basic_link rx-btn--right" href="/#/about-content" target="_blank">
            <span className="rx-btn-text">
              <span className="rx-btn-text-container">Latest update: {data.lastUpdated}</span>
            </span>
            <span className="rx-btn-icon ">
              <i className="ss-navigateright button-icon" />
            </span>
          </a>
        )}
      </div>
      <div className="info-bar">
        <span className="info-bar--item">
          <span className="info-bar--item-num">{data.substances || 0}M</span>
          <span className="info-bar--item-icon">
            <svg className="rx-btn-icon svg-icon">
              <use href="#icon-substances" />
            </svg>
            <span className="rx-btn-text">Substances</span>
          </span>
        </span>

        <span className="info-bar--item">
          <span className="info-bar--item-num">{data.reactions || 0}M</span>
          <span className="info-bar--item-icon">
            <svg className="rx-btn-icon svg-icon">
              <use href="#icon-reactions" />
            </svg>
            <span className="rx-btn-text">Reactions</span>
          </span>
        </span>

        <span className="info-bar--item">
          <span className="info-bar--item-num">{data.citations || 0}M</span>
          <span className="info-bar--item-icon">
            <svg className="rx-btn-icon svg-icon">
              <use href="#icon-citations" />
            </svg>
            <span className="rx-btn-text">Documents</span>
          </span>
        </span>

        <span className="info-bar--item">
          <span className="info-bar--item-num">{data.patents || 0}M</span>
          <span className="info-bar--item-icon">
            <svg className="rx-btn-icon svg-icon">
              <use href="#icon-patents" />
            </svg>
            <span className="rx-btn-text">Patents</span>
          </span>
        </span>

        <span className="info-bar--item">
          <span className="info-bar--item-num">{data.dpitems || 0}M</span>
          <span className="info-bar--item-icon">
            <svg className="rx-btn-icon svg-icon">
              <use href="#icon-tgitems" />
            </svg>
            <span className="rx-btn-text">Bioactivities</span>
          </span>
        </span>
      </div>
    </div>
  );
}

export default InfoBar;
